module.exports = require('./components/emailsignatures');
